/**
 * Модальное окно авторизации с полной блокировкой фона
 */

import { authService, User } from './AuthService.js';
import { showSupportChoice } from '../utils/support';

export class LoginModal {
  private overlay: HTMLElement | null = null;
  private onLoginSuccess: ((user: User) => void) | null = null;

  constructor() {
    // Не создаем при конструкторе - только при show()
  }

  private createModal(): void {
    // Удаляем старое если есть
    const existing = document.getElementById('login-modal-overlay');
    if (existing) {
      existing.remove();
    }

    const overlay = document.createElement('div');
    overlay.id = 'login-modal-overlay';
    overlay.innerHTML = `
      <div class="login-modal">
        <div class="login-logo">
          <div class="login-icon" aria-hidden="true">
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="43.4102" height="43.4102" rx="8.4858" fill="#D9F903"/>
              <path d="M35.0976 20.0403L25.4442 22.5577L33.5873 36.0852L26.8189 36.0372L22.1114 27.5925L17.4409 35.9708L10.7292 35.9233L18.0053 22.5577L8.3125 20.0403V16.6237H35.0981L35.0976 20.0403Z" fill="black"/>
              <path d="M25.4104 13.1377C24.7126 13.7746 23.4915 14.0931 21.7469 14.0931C20.0024 14.0931 18.7987 13.7746 18.1358 13.1377C17.438 12.4689 17.0891 11.6726 17.0891 10.749V9.36363C17.0891 8.40817 17.438 7.61196 18.1358 6.97499C18.7987 6.33802 20.0024 6.01953 21.7469 6.01953C23.4915 6.01953 24.7126 6.33802 25.4104 6.97499C26.0733 7.61196 26.4048 8.40817 26.4048 9.36363V10.749C26.4048 11.6726 26.0733 12.4689 25.4104 13.1377Z" fill="black"/>
            </svg>
          </div>
          <h1>Войти в аккаунт</h1>
        </div>
        
        <form class="login-form" id="login-form">
          <div class="login-error" id="login-error"></div>
          
          <div class="login-field">
            <input type="email" id="login-email" placeholder="Почта" required autocomplete="email">
          </div>
          
          <div class="login-field login-field-password">
            <input type="password" id="login-password" placeholder="Пароль" required autocomplete="current-password">
            <button type="button" class="login-password-toggle" id="login-password-toggle" aria-label="Показать пароль" title="Показать пароль">
              <svg class="login-password-eye login-password-eye-open" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.02362 3C11.3677 3 13.6662 4.83006 14.9191 6.20117C15.7034 7.05944 15.7391 8.31932 14.9748 9.19531C13.782 10.562 11.5441 12.3584 8.02362 12.3584C4.50332 12.3583 2.26618 10.5619 1.07342 9.19531C0.308933 8.31937 0.343937 7.0595 1.12811 6.20117C2.38096 4.83009 4.67956 3.00008 8.02362 3ZM8.02752 5.00586C6.55092 5.00598 5.3537 6.20305 5.3537 7.67969C5.3537 9.15633 6.55092 10.3534 8.02752 10.3535C9.50424 10.3535 10.7014 9.1564 10.7014 7.67969C10.7014 6.20297 9.50424 5.00586 8.02752 5.00586Z" fill="currentColor"/>
              </svg>
              <svg class="login-password-eye login-password-eye-closed" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="display:none">
                <path d="M14.6192 6.05423C14.7587 5.88165 15.0067 5.84163 15.1935 5.96146C15.3803 6.08151 15.446 6.32334 15.3468 6.52201L15.338 6.53959C15.333 6.54929 15.3257 6.56368 15.3165 6.5806C15.2981 6.6146 15.2716 6.66326 15.2364 6.72318C15.1658 6.84352 15.0603 7.01232 14.9191 7.21341C14.7031 7.52093 14.4006 7.90589 14.006 8.30912L14.4825 8.78568C14.7203 9.02351 14.7203 9.40922 14.4825 9.64701C14.2447 9.88476 13.859 9.88472 13.6212 9.64701L13.0929 9.11869C12.6926 9.42697 12.2356 9.72339 11.7179 9.98002L12.1886 10.7945C12.3564 11.0857 12.2561 11.4584 11.965 11.6265C11.6738 11.7946 11.3012 11.6948 11.1329 11.4038L10.5763 10.441C9.97162 10.6328 9.3047 10.7647 8.57237 10.812V11.8257C8.5722 12.1619 8.29923 12.4351 7.963 12.4351C7.62687 12.435 7.3538 12.1618 7.35362 11.8257V10.8101C6.69577 10.7652 6.09135 10.6506 5.53722 10.4869L5.0089 11.4038C4.84071 11.695 4.46713 11.7946 4.17589 11.6265C3.88489 11.4583 3.78526 11.0856 3.95323 10.7945L4.38292 10.0484C3.74425 9.74713 3.19399 9.38488 2.72667 9.00931L2.08995 9.64701C1.85222 9.88455 1.46739 9.88446 1.2296 9.64701C0.991837 9.40924 0.990977 9.02352 1.22862 8.78568L1.83116 8.18216C1.49564 7.82554 1.23333 7.48845 1.04015 7.21341C0.898926 7.01232 0.79338 6.84352 0.722765 6.72318C0.687616 6.66326 0.661069 6.6146 0.642687 6.5806C0.633546 6.56368 0.626243 6.54929 0.621203 6.53959L0.61339 6.52396L0.612414 6.52298C0.513249 6.32432 0.57893 6.08151 0.765734 5.96146C0.952642 5.84155 1.20058 5.88234 1.33995 6.05521C1.34041 6.05577 1.34158 6.05655 1.34288 6.05814C1.34597 6.06186 1.35132 6.06832 1.35851 6.07669C1.37349 6.09413 1.3973 6.12145 1.4298 6.15677C1.49547 6.22813 1.59711 6.33343 1.73351 6.46048C2.00682 6.71503 2.42071 7.05886 2.97472 7.40287C4.08128 8.08992 5.74794 8.7808 7.9796 8.7808C10.2113 8.7808 11.8779 8.08992 12.9845 7.40287C13.5385 7.05886 13.9524 6.71503 14.2257 6.46048C14.3621 6.33343 14.4637 6.22813 14.5294 6.15677C14.5619 6.12145 14.5857 6.09413 14.6007 6.07669C14.6079 6.06832 14.6132 6.06186 14.6163 6.05814C14.6176 6.05655 14.6188 6.0548 14.6192 6.05423Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          
          <button type="submit" class="login-btn" id="login-btn">Войти</button>
          
          <div class="login-help">
            Не можете войти? <a href="#" class="login-help-link" id="login-support-link">Напишите в поддержку</a>
          </div>
        </form>
      </div>
    `;

    // Добавляем стили
    const style = document.createElement('style');
    style.id = 'login-modal-styles';
    style.textContent = `
      #login-modal-overlay {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        background: #000000 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        z-index: 999999 !important;
        font-family: 'IBM Plex Mono', monospace !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      #login-modal-overlay.hidden {
        display: none !important;
      }
      
      #login-modal-overlay .login-modal {
        background: transparent;
        padding: 40px;
        width: 100%;
        max-width: 400px;
      }
      
      #login-modal-overlay .login-logo {
        text-align: center;
        margin-bottom: 32px;
      }
      
      #login-modal-overlay .login-icon {
        display: flex;
        justify-content: center;
        margin-bottom: 24px;
      }
      
      #login-modal-overlay .login-logo h1 {
        font-size: 24px;
        font-weight: 700;
        color: #fff;
        margin: 0;
        font-family: 'IBM Plex Mono', monospace;
      }
      
      #login-modal-overlay .login-form {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      
      #login-modal-overlay .login-field {
        display: flex;
        flex-direction: column;
      }
      
      #login-modal-overlay .login-field-password {
        position: relative;
      }
      
      #login-modal-overlay .login-field-password input {
        padding-right: 48px;
      }
      
      #login-modal-overlay .login-password-toggle {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 32px;
        height: 32px;
        padding: 0;
        border: none;
        background: none;
        color: #888;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        transition: color 0.2s;
      }
      
      #login-modal-overlay .login-password-toggle:hover {
        color: #fff;
      }
      
      #login-modal-overlay .login-field input {
        background: #111;
        border: 1px solid #444;
        border-radius: 8px;
        padding: 14px 16px;
        font-size: 15px;
        color: #fff;
        outline: none;
        transition: border-color 0.2s;
        width: 100%;
        box-sizing: border-box;
        font-family: 'IBM Plex Mono', monospace;
      }
      
      #login-modal-overlay .login-field input:focus {
        border-color: #666;
      }
      
      #login-modal-overlay .login-field input::placeholder {
        color: #888;
      }
      
      #login-modal-overlay .login-btn {
        background: #D9F903;
        color: #000;
        border: none;
        border-radius: 8px;
        padding: 14px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.2s, transform 0.1s;
        margin-top: 8px;
        width: 100%;
        font-family: 'IBM Plex Mono', monospace;
      }
      
      #login-modal-overlay .login-btn:hover {
        opacity: 0.9;
      }
      
      #login-modal-overlay .login-btn:active {
        transform: scale(0.98);
      }
      
      #login-modal-overlay .login-btn:disabled {
        background: #333;
        color: #666;
        cursor: not-allowed;
      }
      
      #login-modal-overlay .login-error {
        background: rgba(239, 68, 68, 0.1);
        border: 1px solid rgba(239, 68, 68, 0.3);
        border-radius: 8px;
        padding: 12px;
        color: #ef4444;
        font-size: 13px;
        text-align: center;
        display: none;
      }
      
      #login-modal-overlay .login-error.visible {
        display: block;
      }
      
      #login-modal-overlay .login-help {
        text-align: center;
        font-size: 12px;
        color: #666;
        margin-top: 12px;
      }
      
      #login-modal-overlay .login-help-link {
        color: #D9F903;
        text-decoration: none;
        transition: opacity 0.2s;
      }
      
      #login-modal-overlay .login-help-link:hover {
        opacity: 0.9;
        text-decoration: underline;
      }
    `;

    // Удаляем старые стили если есть
    const existingStyle = document.getElementById('login-modal-styles');
    if (existingStyle) {
      existingStyle.remove();
    }

    document.head.appendChild(style);
    document.body.appendChild(overlay);
    this.overlay = overlay;

    // Обработчик формы
    const form = document.getElementById('login-form') as HTMLFormElement;
    form.addEventListener('submit', (e) => this.handleSubmit(e));

    // Показать/скрыть пароль
    const passwordToggle = document.getElementById('login-password-toggle');
    const passwordInput = document.getElementById('login-password') as HTMLInputElement;
    if (passwordToggle && passwordInput) {
      const eyeOpen = passwordToggle.querySelector('.login-password-eye-open') as HTMLElement;
      const eyeClosed = passwordToggle.querySelector('.login-password-eye-closed') as HTMLElement;
      passwordToggle.addEventListener('click', () => {
        const isPassword = passwordInput.type === 'password';
        passwordInput.type = isPassword ? 'text' : 'password';
        if (eyeOpen && eyeClosed) {
          eyeOpen.style.display = isPassword ? 'none' : 'block';
          eyeClosed.style.display = isPassword ? 'block' : 'none';
        }
        passwordToggle.setAttribute('aria-label', isPassword ? 'Скрыть пароль' : 'Показать пароль');
        passwordToggle.setAttribute('title', isPassword ? 'Скрыть пароль' : 'Показать пароль');
      });
    }

    document.getElementById('login-support-link')?.addEventListener('click', (e) => {
      e.preventDefault();
      showSupportChoice();
    });

    // Блокируем все события на document пока открыто окно
    this.blockBackground();
  }

  private blockBackground(): void {
    // Блокируем scroll
    document.body.style.overflow = 'hidden';
    
    // Блокируем все pointer events кроме нашего модала
    const allElements = document.querySelectorAll('body > *:not(#login-modal-overlay):not(#login-modal-styles)');
    allElements.forEach(el => {
      (el as HTMLElement).style.pointerEvents = 'none';
    });
  }
  
  private unblockBackground(): void {
    document.body.style.overflow = '';
    
    const allElements = document.querySelectorAll('body > *');
    allElements.forEach(el => {
      (el as HTMLElement).style.pointerEvents = '';
    });
  }

  private async handleSubmit(e: Event): Promise<void> {
    e.preventDefault();
    e.stopPropagation();

    const emailInput = document.getElementById('login-email') as HTMLInputElement;
    const passwordInput = document.getElementById('login-password') as HTMLInputElement;
    const errorDiv = document.getElementById('login-error') as HTMLElement;
    const submitBtn = document.getElementById('login-btn') as HTMLButtonElement;

    const email = emailInput.value.trim();
    const password = passwordInput.value;

    if (!email || !password) {
      this.showError('Заполните все поля');
      return;
    }

    // Блокируем кнопку
    submitBtn.disabled = true;
    submitBtn.textContent = 'Вход...';
    errorDiv.classList.remove('visible');

    const result = await authService.login(email, password);

    if (result.success) {
      const user = authService.getUser();
      this.hide();
      if (user && this.onLoginSuccess) {
        this.onLoginSuccess(user);
      }
    } else {
      this.showError(result.error || 'Ошибка авторизации');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Войти';
    }
  }

  private showError(message: string): void {
    const errorDiv = document.getElementById('login-error') as HTMLElement;
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.add('visible');
    }
  }

  show(onSuccess?: (user: User) => void): void {
    if (onSuccess) this.onLoginSuccess = onSuccess;
    
    this.createModal();
    
    // Фокус на email
    setTimeout(() => {
      const emailInput = document.getElementById('login-email') as HTMLInputElement;
      emailInput?.focus();
    }, 100);
  }

  hide(): void {
    this.unblockBackground();
    
    if (this.overlay) {
      this.overlay.remove();
      this.overlay = null;
    }
    
    const style = document.getElementById('login-modal-styles');
    if (style) {
      style.remove();
    }
  }

  isVisible(): boolean {
    return !!this.overlay && document.body.contains(this.overlay);
  }
}

// Singleton
export const loginModal = new LoginModal();
export default loginModal;
